<template>
  <el-dialog
    :title="$t('order.payment.dialogTitle')"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="payment-container">
      <div class="payment-header">
        <p>{{ $t('order.payment.subjectLabel') }}{{ orderSubject || $t('order.defaultSubject') }}</p>
        <p class="price">¥ {{ orderAmount ? (orderAmount / 100).toFixed(2) : '0.00' }}</p>
      </div>

      <el-radio-group v-model="selectedPaymentMethod" class="payment-methods">
        <el-radio label="wechat" v-if="currentPayment3id">{{ $t('order.payment.wechatPay') }}</el-radio>
        <el-radio label="alipay" v-if="currentPayment2id">{{ $t('order.payment.alipay') }}</el-radio>
        <el-radio label="transfer" v-if="currentPayment4id">{{ $t('order.payment.bankTransfer') }}</el-radio>
      </el-radio-group>

      <!-- 微信/支付宝二维码区域 -->
      <div v-if="selectedPaymentMethod === 'wechat' || selectedPaymentMethod === 'alipay'" class="qrcode-section">
        <vue-qrcode
          display-value="false"
          :value="getPaymentQrcodeUrl()"
          :color="{ dark: '#000000' }"
          type="image/png"
          :size="200"
          @change="onPaymentQrcodeChange"
        />
        <img
          v-if="paymentQrcodeDataUrl"
          :src="paymentQrcodeDataUrl"
          :alt="selectedPaymentMethod === 'wechat' ? $t('order.payment.wechatPay') : $t('order.payment.alipay')"
          class="payment-qrcode"
        />
        <p class="mt-10">{{ $t('order.payment.scanTip', { payType: selectedPaymentMethod === 'wechat' ? $t('order.payment.wechatPay') : $t('order.payment.alipay') }) }}</p>
        <p class="mt-5 text-red">{{ $t('order.payment.finishTip') }}</p>
      </div>

      <!-- 对公转账信息 + 内置上传区域 -->
      <div v-else-if="selectedPaymentMethod === 'transfer'" class="transfer-info-section">
        <div class="account-card">
          <div class="account-row">
            <label>{{ $t('order.payment.receiveUnit') }}</label>
            <span>{{ transferAccountInfo.name || '-' }}</span>
          </div>
          <div class="account-row">
            <label>{{ $t('order.payment.bankNo') }}</label>
            <span>{{ transferAccountInfo.no || '-' }}</span>
          </div>
          <div class="account-row">
            <label>{{ $t('order.payment.bankBranch') }}</label>
            <span>{{ transferAccountInfo.branch || '-' }}</span>
          </div>
          <div v-if="transferAccountInfo.remark" class="account-row remark-row">
            <label>{{ $t('common.tip') }}：</label>
            <span class="text-red">{{ transferAccountInfo.remark }}</span>
          </div>
        </div>

        <div class="upload-wrap">
          <p class="upload-tip">{{ $t('order.payment.uploadTip') }}</p>
          <el-upload
            ref="uploadRef"
            class="upload-box"
            action=""
            :http-request="customUpload"
            :limit="1"
            accept="image/png,image/jpg,image/jpeg"
            :on-exceed="handleExceed"
            :on-remove="handleRemoveFile"
          >
            <el-button type="primary">{{ $t('order.payment.selectImageBtn') }}</el-button>
          </el-upload>
          <div v-if="proofFile" class="file-name">
            {{ $t('order.payment.selectedFile', { name: proofFile.name }) }}
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="handlePaymentCompleted"
        :loading="paymentLoading"
      >
        {{ selectedPaymentMethod === 'transfer' ? $t('order.payment.btnSubmitProof') : $t('order.payment.btnPaid') }}
      </el-button>
      <el-button @click="handleCancel">{{ $t('common.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import config from '@/config'
import { getPaychannels } from "@/api/event"
import { getOrder, postCharge } from '@/api/order'
import { postOrderPaidproof } from '@/api/user'

export default {
  name: 'PaymentDialog',
  components: {
    VueQrcode
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    orderSubject: {
      type: String,
      default: ''
    },
    orderAmount: {
      type: Number,
      default: 0
    },
    propPayment2id: {
      type: String,
      default: ''
    },
    propPayment3id: {
      type: String,
      default: ''
    },
    propPayment4id: {
      type: String,
      default: ''
    },
    autoFetchPayments: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      selectedPaymentMethod: 'wechat',
      paymentLoading: false,
      paymentQrcodeDataUrl: '',
      alipayQrcodeDataUrl: '',
      innerPayment2id: '',
      innerPayment3id: '',
      innerPayment4id: '',
      transferAccountInfo: {
        name: '',
        no: '',
        branch: '',
        remark: ''
      },
      proofFile: null,
      transferChargeId: ''
    }
  },
  computed: {
    currentPayment2id() {
      return this.innerPayment2id || this.propPayment2id
    },
    currentPayment3id() {
      return this.innerPayment3id || this.propPayment3id
    },
    currentPayment4id() {
      return this.innerPayment4id || this.propPayment4id
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.autoFetchPayments && this.orderId) {
        this.fetchPaymentsData()
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false)
      }
    },
    selectedPaymentMethod(val) {
      this.paymentQrcodeDataUrl = ''
      this.proofFile = null
      this.transferChargeId = ''

      if (val === 'alipay') {
        this.alipayQrcodeDataUrl = ''
        if (this.orderId && this.currentPayment2id) {
          this.fetchAlipayQrcode()
        }
      }
      if (val === 'transfer') {
        this.fetchTransferCharge()
      }
    }
  },
  methods: {
    async fetchPaymentsData() {
      try {
        const res = await getPaychannels(this.orderId)
        if (res.code === 200 && res.list && res.list.length > 0) {
          const payment3Item = res.list.find(item => item.paysource === 3)
          if (payment3Item && payment3Item.id) {
            this.innerPayment3id = payment3Item.id
          }
          const payment2Item = res.list.find(item => item.paysource === 2)
          if (payment2Item && payment2Item.id) {
            this.innerPayment2id = payment2Item.id
          }
          const payment4Item = res.list.find(item => item.paysource === 4)
          if (payment4Item && payment4Item.id) {
            this.innerPayment4id = payment4Item.id
            if (payment4Item.config) {
              this.transferAccountInfo.name = payment4Item.config.name || ''
              this.transferAccountInfo.no = payment4Item.config.no || ''
              this.transferAccountInfo.branch = payment4Item.config.branch || ''
            }
            this.transferAccountInfo.remark = payment4Item.remark || ''
          }

          if (this.currentPayment3id) {
            this.selectedPaymentMethod = 'wechat'
          } else if (this.currentPayment2id) {
            this.selectedPaymentMethod = 'alipay'
          } else if (this.currentPayment4id) {
            this.selectedPaymentMethod = 'transfer'
          }
        }
      } catch (error) {
        console.error('获取支付配置失败:', error)
        this.$message.error(this.$t('order.paymentConfigFailed'))
      }
    },

    async fetchAlipayQrcode() {
      try {
        const res = await postCharge({
          orderid: this.orderId,
          paychannelid: this.currentPayment2id,
        })
        if (res.code === 201) {
          this.alipayQrcodeDataUrl = res.data.qr_code
        }
      } catch (error) {
        console.error('获取支付宝二维码失败:', error)
        this.$message.error('获取支付宝支付二维码失败')
      }
    },

    // 创建对公转账charge，获取chargeId
    async fetchTransferCharge() {
      try {
        const res = await postCharge({
          orderid: this.orderId,
          paychannelid: this.currentPayment4id,
        })
        console.log('transferCharge:',res);
        if (res.code === 201) {
          this.transferChargeId = res.data.id
        } else {
          this.$message.warning('初始化对公支付失败')
        }
      } catch (error) {
        console.error('获取对公chargeid失败：', error)
        this.$message.error('对公支付通道初始化失败')
      }
    },

    getPaymentQrcodeUrl() {
      if (!this.orderId || !this.currentPayment3id) {
        return ''
      }
      if (this.selectedPaymentMethod === 'wechat') {
        return `${config.WX_BASE_URL}pay?id=${this.orderId}&paychannelid=${this.currentPayment3id}`
      } else if (this.selectedPaymentMethod === 'alipay') {
        return this.alipayQrcodeDataUrl
      }
      return ''
    },

    onPaymentQrcodeChange(dataUrl) {
      this.paymentQrcodeDataUrl = dataUrl
    },

    handlePaymentCompleted() {
      if (this.selectedPaymentMethod === 'transfer') {
        this.submitTransferProof()
      } else {
        this.doCheckOnlinePay()
      }
    },

    // 微信/支付宝 我已付款
    async doCheckOnlinePay() {
      if (!this.orderId) {
        this.$message.error('订单ID不存在')
        return
      }
      this.paymentLoading = true
      try {
        const result = await getOrder(this.orderId)
        const res = result.data
        if (res.paystatus == 99 || res.paystatus == 100 || res.paystatus == 50) {
          this.$message.success(this.$t('order.payConfirmSuccess'))
          this.dialogVisible = false
          this.selectedPaymentMethod = 'wechat'
          this.$emit('payment-success', res)
        } else {
          this.$message.error(this.$t('order.payFailed'))
        }
      } catch (error) {
        this.$message.error(this.$t('order.payConfirmFailed'))
      } finally {
        this.paymentLoading = false
      }
    },

    customUpload(options) {
      this.proofFile = options.file
    },
    handleExceed() {
      this.$message.warning(this.$t('order.payment.msgOnlyOneImage'))
    },
    handleRemoveFile() {
      this.proofFile = null
    },

    // 提交转账凭证
    async submitTransferProof() {
      if (!this.proofFile) {
        this.$message.warning(this.$t('order.payment.msgSelectFile'))
        return
      }
      if (!this.transferChargeId) {
        this.$message.warning(this.$t('order.payment.msgChargeInitWait'))
        return
      }

      this.paymentLoading = true
      try {
        const extraParams = {}
        // 对齐你接口参数顺序：postOrderPaidproof(orderid, chargeid, fileProof, params)
        const res = await postOrderPaidproof(
          this.orderId,
          this.transferChargeId,
          this.proofFile,
          extraParams
        )

        if (res.code < 300) {
          this.$message.success(this.$t('order.payment.msgProofSuccess'))
          this.dialogVisible = false
          this.proofFile = null
          this.transferChargeId = ''
          this.$emit('payment-success')
        } else {
          this.$message.error(res.msg || this.$t('order.payment.msgProofFail'))
        }
      } catch (err) {
        console.error(err)
        this.$message.error(this.$t('order.payment.msgUploadFail'))
      } finally {
        this.paymentLoading = false
      }
    },

    handleCancel() {
      this.dialogVisible = false
      this.$emit('payment-cancel')
    },

    handleClose() {
      this.dialogVisible = false
      this.proofFile = null
      this.transferChargeId = ''
      this.$emit('update:visible', false)
      this.$emit('payment-cancel')
    },

    resetPayment() {
      this.selectedPaymentMethod = 'wechat'
      this.paymentQrcodeDataUrl = ''
      this.alipayQrcodeDataUrl = ''
      this.paymentLoading = false
      this.proofFile = null
      this.transferChargeId = ''
    }
  }
}
</script>

<style scoped>
.payment-container {
  text-align: center;
}
.payment-header {
  text-align: center;
  margin-bottom: 20px;
}
.price {
  font-size: 24px;
  font-weight: bold;
  color: #F56C6C;
  margin-top: 10px;
}
.payment-methods {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  gap: 20px;
  justify-content: center;
}
.qrcode-section {
  text-align: center;
  padding: 10px 0;
}
.transfer-info-section {
  padding: 15px 10px;
}
.account-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  text-align: left;
  margin: 0 auto;
  background: #fbfcff;
}
.account-row {
  display: flex;
  line-height: 2.2;
  font-size: 15px;
}
.account-row label {
  width: 90px;
  font-weight: 500;
  color: #303133;
}
.upload-wrap {
  margin-top: 20px;
  padding-top:16px;
  border-top:1px dashed #ddd;
}
.upload-tip{
  margin:0 0 12px;
  color:#666;
}
.file-name{
  margin-top:8px;
  color:#409EFF;
}
.payment-qrcode {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-10 {
  margin-top: 10px;
}
.text-red {
  color: #F56C6C;
  font-size: 13px;
}
:deep(.el-dialog__body) {
  padding: 0 20px 20px 20px;
}
</style>